import { ErrorReporter } from "@/api/client/ErrorReporter";

ErrorReporter.register();
